import {Button} from "inferno-bootstrap";
import ChevronDown from "inferno-feather/dist/icons/chevron-down";
import ChevronUp from "inferno-feather/dist/icons/chevron-up";
import {Tooltip} from "../Tooltip";
import {Configuration} from "../../services/configuration";

export function Minimize(props: { minimized: boolean, onMinimize: (event: MouseEvent) => void }) {
	return (
		<Button color="primary" onClick={props.onMinimize}>
			<ChevronUp id="max-btn" className={(props.minimized ? "" : " d-none")}/>
			{ !Configuration.isMobile ? <Tooltip target="max-btn" content="VCC_XTOL_HEADER_MAXIMIZE_TOOLTIP"/> : null}
			<ChevronDown id="min-btn" className={(!props.minimized ? "" : " d-none")}/>
			{ !Configuration.isMobile ? <Tooltip target="min-btn" content="VCC_XTOL_HEADER_MINIMIZE_TOOLTIP"/> : null}
		</Button>
	);
}
